/**
 * @name 下载
 */
// import base from '../base';
import Download from './download';

Download.install = function(Vue) {
  // Vue.use(base);
  Vue.component(Download.name, Download);
};

export default Download;
